import React, { SVGProps } from "react";

interface MediaIconProps extends SVGProps<SVGSVGElement> {}
const MediaIcon: React.FC<MediaIconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={17}
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m1.957 4.805 2.742 2.764 2.876-2.694L5.99 3.29 4.536 4.744l-.848-.848 1.454-1.454-.408-.409a1 1 0 0 0-1.415 0l-1.36 1.36a1 1 0 0 0-.002 1.412Zm-.852.845 2.717 2.739L.318 11.67l-.221 2.745-.097 1.2 1.204-.001 2.754-.003 3.676-3.441 2.761 2.761a2.2 2.2 0 0 0 3.111 0l1.356-1.355a2.2 2.2 0 0 0 0-3.112L12.247 7.85l3.071-2.876a1.6 1.6 0 0 0 .082-2.253l-1.468-1.59a1.6 1.6 0 0 0-2.27-.083l-3.21 3.006-2.87-2.87a2.2 2.2 0 0 0-3.111 0l-1.36 1.36a2.2 2.2 0 0 0-.006 3.106Zm10.139 8.433L8.51 11.349l2.86-2.679 1.092 1.092-1.454 1.454.849.849 1.454-1.454.702.702a1 1 0 0 1 0 1.414l-1.355 1.356a1 1 0 0 1-1.414 0Zm1.454-8.3 1.8-1.685a.4.4 0 0 0 .02-.563l-1.468-1.59a.4.4 0 0 0-.567-.021l-1.797 1.682 2.012 2.177Zm-.876.82-8.339 7.809-2.182.002.176-2.185L9.81 4.426l2.012 2.178Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default MediaIcon;
